<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card title="Product Frequency">
      <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>
      <p class="pb-3">
        This is a history of {{ productHelpers.getPreferredName(product) }}'s frequencies. The most recent entry (last) will be used for scans.
      </p>

      <vs-collapse v-if="!loading" accordion type="border" class="mb-2">

        <vs-collapse-item
          v-for="frequency in frequencies"
          :key="frequency.id">
          <div slot="header">
            {{ frequencyHelpers.frequencyString(frequency) }} - ({{ frequencyHelpers.date(frequency) }})
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <span>Weight: {{ frequencyHelpers.weightString(frequency) }}</span>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-textarea
                disabled
                style="color: darkgray;"
                :value="frequency.note"
                label="Note"
                class="w-full"
              />
            </div>
          </div>

        </vs-collapse-item>

      </vs-collapse>

      <vs-button class="ml-auto mt-5 pt-2" color="primary" type="border" icon-after icon="add" @click="showCreateFrequencyDialog">New Frequency Measurement</vs-button>

      <vs-prompt
        @accept="createFrequency"
        title="New Frequency Measurement"
        :active.sync="showCreateFrequencyDialogFlag">
        <div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input
                class="w-full mb-1"
                label-placeholder="Frequency (MHz)"
                v-model="newFrequencyModel.frequency"
              />
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input
                class="w-full mb-1"
                label-placeholder="Weight in grams (optional)"
                v-model="newFrequencyModel.weight"
              />
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-textarea
                class="w-full mb-1"
                label="Note (optional)"
                v-model="newFrequencyModel.note"
              />
            </div>
          </div>

        </div>
      </vs-prompt>

    </vx-card>
<!--    <div v-html="jp.toHtml(cyclopedias)"></div>-->
</template>

<script>
  import api from '@/http/api';
  import models from '@/models';
  import jsonPrinter from '@/misc/jsonHtmlPrinter';
  import { productFrequencyHelpers, productHelpers } from '@/models/helpers'

  export default {
    components: {},
    data() {
      return {
        loading: false,
        models: models,
        jp: jsonPrinter,
        productHelpers: productHelpers,
        frequencyHelpers: productFrequencyHelpers,
        frequencies: [],
        showCreateFrequencyDialogFlag: false,
        newFrequencyModel: new models.ProductFrequency(),

      }
    },
    computed: {
      productId() {
        return this.$route.query.id || null;
      },
    },
    props: {
      product: {
        type: models.Product(),
        required: true,
        default: () => {
          return new models.Product()
        }
      },
    },
    mounted() {
      this.fetchFrequencies();
    },
    methods: {
      async createFrequency() {
        this.newFrequencyModel.frequency = +this.newFrequencyModel.frequency;
        if (this.newFrequencyModel.frequency === 0 || isNaN(this.newFrequencyModel.frequency)) {
          this.showCreateFrequencyDialog(this.newFrequencyModel);
          this.showNotification(false, 'The frequency must be a number.');
          return;
        }
        if (this.newFrequencyModel.weight && isNaN(+this.newFrequencyModel.weight)) {
          this.showCreateFrequencyDialog(this.newFrequencyModel);
          this.showNotification(false, 'The weight must be a number.');
          return;
        }
        if (!this.newFrequencyModel.weight) {
          this.newFrequencyModel.weight = null;
        }
        this.loading = true;

        let newFrequency = await api.createProductFrequency(this.newFrequencyModel);

        if (newFrequency !== null && newFrequency.id > 0) {
          await this.fetchFrequencies();
          this.showNotification(true, 'Frequency added');
        } else {
          this.showNotification(false, 'Error adding frequency');
        }

        this.loading = false;
      },
      async fetchFrequencies() {
        this.loading = true;
        this.frequencies = await api.fetchProductFrequencies(this.productId);
        this.loading = false;
      },
      showCreateFrequencyDialog(frequency) {
        this.newFrequencyModel = new models.ProductFrequency(frequency);
        this.newFrequencyModel.product_id = this.productId;
        this.showCreateFrequencyDialogFlag = true;
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    },
  }

</script>


<style lang="scss">

</style>

